export default function CampaignSection() {
  const campaigns = [
    {
      name: '三井住友カード（NL）',
      bonus: '最大25,600円相当',
      conditions: '新規入会＋利用で最大25,600円相当のVポイントプレゼント',
      deadline: '終了日未定',
      url: 'https://www.smbc-card.com/'
    },
    {
      name: '大手ECモール系カード',
      bonus: '5,000ポイント',
      conditions: '新規入会＋利用で5,000ポイント進呈',
      deadline: '終了日未定',
      url: 'https://www.rakuten-card.co.jp/'
    },
    {
      name: 'リクルートカード',
      bonus: '最大6,000円分',
      conditions: '新規入会＋利用で最大6,000円分のポイントプレゼント',
      deadline: '終了日未定',
      url: 'https://recruit-card.jp/'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#14B8A6]/10 to-[#0F9B8E]/10">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block bg-[#14B8A6] text-white text-sm px-4 py-2 rounded-full font-bold mb-4">
            🎁 学生限定キャンペーン情報
          </div>
          <h3 className="text-3xl font-bold mb-4 text-[#003366]">
            今月のおすすめキャンペーン
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto">
            現在、以下のカードで学生向けの入会特典キャンペーンを実施中です。終了日未定のため、早めの申込みがおすすめです。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {campaigns.map((campaign, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all border-2 border-transparent hover:border-[#14B8A6]"
            >
              <div className="text-center mb-4">
                <div className="inline-block bg-gradient-to-r from-[#14B8A6] to-[#0F9B8E] text-white text-2xl font-bold px-6 py-3 rounded-lg mb-3">
                  {campaign.bonus}
                </div>
                <h4 className="text-xl font-bold text-[#003366]">{campaign.name}</h4>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-2">
                  <i className="ri-gift-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <p className="text-sm text-gray-700">{campaign.conditions}</p>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-time-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <p className="text-sm text-gray-700">{campaign.deadline}</p>
                </div>
              </div>

              <a
                href={campaign.url}
                className="block w-full bg-[#14B8A6] text-white px-6 py-3 rounded-lg font-bold text-center hover:bg-[#0F9B8E] transition-all cursor-pointer whitespace-nowrap"
              >
                キャンペーン詳細を見る
              </a>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl p-6 shadow-md">
          <h4 className="font-bold text-lg mb-3 text-[#003366] flex items-center gap-2">
            <i className="ri-information-line text-[#14B8A6] text-xl w-6 h-6 flex items-center justify-center"></i>
            キャンペーン適用の注意点
          </h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
              <span>キャンペーン特典を受け取るには、各カード会社の条件を満たす必要があります。</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
              <span>特典の進呈時期はカード会社によって異なります。詳細は公式サイトをご確認ください。</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
              <span>キャンペーン内容は予告なく変更・終了する場合があります。</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
